const injectDeleteButtonStyles = () => {
    const deleteButtonStyleId = 'impowerx-delete-button-styles'
    if (document.getElementById(deleteButtonStyleId)) return

    const deleteButtonStyle = document.createElement('style')
    deleteButtonStyle.id = deleteButtonStyleId
    deleteButtonStyle.textContent = `
      .delete-button:disabled {
        cursor: not-allowed !important;
        pointer-events: none !important;
        .anticon svg path {
          fill: #777777 !important;
        }
        .anticon svg {
          fill: #777777 !important;
        }
      }
    `
    document.head.appendChild(deleteButtonStyle)
}

const injectFileInputStyles = () => {
    const fileInputStyleId = 'impowerx-file-input-styles'
    if (document.getElementById(fileInputStyleId)) return

    const fileInputStyle = document.createElement('style')
    fileInputStyle.id = fileInputStyleId
    fileInputStyle.textContent = `
      .impower-x-file-input:disabled,
      .impower-x-file-input[disabled],
      .file-input-label:disabled,
      .file-input-label[disabled],
      .impower-x:disabled,
      .impower-x[disabled] {
        color: #777777 !important;
        cursor: not-allowed !important;
        pointer-events: none !important;
        .anticon svg path {
          fill: #777777 !important;
        }
        .anticon svg {
          fill: #777777 !important;
        }
        .Button.ant-btn {
          color: #777777 !important;
        }
      }
    `
    document.head.appendChild(fileInputStyle)
}

const injectDropdownMenuStyles = () => {
    const dropdownMenuStyleId = 'impowerx-dropdown-menu-styles'
    if (document.getElementById(dropdownMenuStyleId)) return

    const dropdownMenuStyle = document.createElement('style')
    dropdownMenuStyle.id = dropdownMenuStyleId
    dropdownMenuStyle.textContent = `
      .impowerx-select-menu-item{
        padding: 0.7rem;
        margin: 0;
        &:hover {
          background: #f5f5f5 !important;
        }
      }
    `
    document.head.appendChild(dropdownMenuStyle)
}

const injectContractDocumentsSectionStyles = () => {
    const styleId = 'impowerx-contract-documents-section-styles'
    if (document.getElementById(styleId)) return

    const style = document.createElement('style')
    style.id = styleId
    style.textContent = `
      #lux-contract-documents-section.sub-section {
        margin-top: 3.2rem !important;
      }
    `
    document.head.appendChild(style)
}

/** Hide Impower-native building service-provider editors (contacts live in ContactRoles). */
const injectHideBuildingServiceProvidersStyles = () => {
    const styleId = 'lux-hide-building-service-providers'
    if (document.getElementById(styleId)) return

    const style = document.createElement('style')
    style.id = styleId
    style.textContent = `
      /* e.g. #building0serviceProviders */
      .sub-section[id$="serviceProviders"],
      .sub-section[data-lux-hide-objektdienste="1"],
      .FormSidebar .Link.sub-link[data-lux-hide-objektdienste="1"],
      /* Versorgung (utilities) — contacts live in ContactRoles */
      .sub-section[data-lux-hide-versorgung="1"],
      .FormSidebar .Link.sub-link[data-lux-hide-versorgung="1"] {
        display: none !important;
      }
    `
    document.head.appendChild(style)
}

const OBJEKTDIENSTE_TITLE_RE = /Objektdienste/i

/** Mark sidebar + content nodes whose title contains "Objektdienste" (no stable sidebar ids). */
const hideObjektdiensteBuildingServiceUi = () => {
    document.querySelectorAll('.FormSidebar .Link.sub-link').forEach((link) => {
        const title = link.querySelector('.link-title')?.textContent?.trim() || ''
        if (OBJEKTDIENSTE_TITLE_RE.test(title)) {
            link.setAttribute('data-lux-hide-objektdienste', '1')
        }
    })

    document.querySelectorAll('.sub-section').forEach((section) => {
        if (section.id && /serviceProviders$/i.test(section.id)) {
            section.setAttribute('data-lux-hide-objektdienste', '1')
            return
        }
        const title = section.querySelector('.sub-section-title')?.textContent?.trim() || ''
        if (OBJEKTDIENSTE_TITLE_RE.test(title)) {
            section.setAttribute('data-lux-hide-objektdienste', '1')
        }
    })
}

const VERSORGUNG_TITLE_RE = /Versorgung/i

/**
 * Mark sidebar + content nodes for Impower-native "Versorgung" (utilities).
 * Title-based: Impower labels like "Versorgung - Gebäude №1" have no stable sidebar ids.
 */
const hideVersorgungBuildingServiceUi = () => {
    document.querySelectorAll('.FormSidebar .Link.sub-link').forEach((link) => {
        const title = link.querySelector('.link-title')?.textContent?.trim() || ''
        if (VERSORGUNG_TITLE_RE.test(title)) {
            link.setAttribute('data-lux-hide-versorgung', '1')
        }
    })

    document.querySelectorAll('.sub-section').forEach((section) => {
        const title = section.querySelector('.sub-section-title')?.textContent?.trim() || ''
        if (VERSORGUNG_TITLE_RE.test(title)) {
            section.setAttribute('data-lux-hide-versorgung', '1')
        }
    })
}

const IMPOWER_DIENSTLEISTER_SECTION_TITLE = 'Versicherungen'
const DIENSTLEISTER_TITLE_RE = /^(\d+\s+)?Dienstleister$/i

/**
 * Rename Impower's native "Dienstleister" property section (insurance/utilities)
 * without touching Lux ContactRolesSection (also labeled "Dienstleister").
 */
const renameImpowerDienstleisterSection = () => {
    const insuranceAnchor =
        document.getElementById('insuranceIdentity') ||
        document.getElementById('insurance-weg') ||
        document.querySelector('[id^="insurance-building-"]')
    let section = insuranceAnchor?.closest('.FormSection') || null

    if (!section) {
        document.querySelectorAll('.FormSection').forEach((el) => {
            if (el.id === 'ContactRolesSection') return
            const title = el.querySelector('.main-section-header .section-title')?.textContent?.trim() || ''
            if (DIENSTLEISTER_TITLE_RE.test(title) || title === 'Dienstleister') {
                section = el
            }
        })
    }

    if (!section || section.id === 'ContactRolesSection') return

    const titleEl = section.querySelector('.main-section-header .section-title')
    if (titleEl) {
        const current = titleEl.textContent?.trim() || ''
        if (current !== IMPOWER_DIENSTLEISTER_SECTION_TITLE) {
            titleEl.textContent = IMPOWER_DIENSTLEISTER_SECTION_TITLE
        }
    }

    const sectionNumber =
        section.querySelector('.main-section-header .section-number')?.textContent?.trim() || ''

    document.querySelectorAll('.FormSidebar .Link.main-link').forEach((link) => {
        if (link.getAttribute('data-section-id') === 'ContactRolesSection') return
        const titleNode = link.querySelector('.link-title')
        if (!titleNode) return
        const text = titleNode.textContent?.trim() || ''
        const matchesTitle = DIENSTLEISTER_TITLE_RE.test(text) || /\bDienstleister\b/i.test(text)
        const matchesNumber =
            sectionNumber &&
            (text.startsWith(`${sectionNumber}\u00a0`) ||
                text.startsWith(`${sectionNumber} `) ||
                text.startsWith(sectionNumber))
        if (!matchesTitle && !(matchesNumber && /Dienstleister/i.test(text))) return
        const prefix = sectionNumber ? `${sectionNumber}\u00a0\u00a0\u00a0\u00a0` : ''
        const next = `${prefix}${IMPOWER_DIENSTLEISTER_SECTION_TITLE}`
        if (titleNode.textContent !== next) titleNode.textContent = next
    })
}

const injectImpowerXStyles = () => {
    injectFileInputStyles()
    injectDeleteButtonStyles()
    injectDropdownMenuStyles()
    injectContractDocumentsSectionStyles()
}

